module.exports = __webpack_public_path__ + "img/3.787c815f.jpg";